module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "playerForm",
    staticStyle: {
      "padding-top": "40px"
    },
    attrs: {
      "model": _vm.playerForm,
      "label-width": "120px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('span', [_vm._v("最大表示件数")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "関連動画",
      "prop": "related"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 20
    },
    model: {
      value: (_vm.playerForm.related),
      callback: function($$v) {
        _vm.$set(_vm.playerForm, "related", $$v)
      },
      expression: "playerForm.related"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "おすすめ動画",
      "prop": "recommend"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 20
    },
    model: {
      value: (_vm.playerForm.recommend),
      callback: function($$v) {
        _vm.$set(_vm.playerForm, "recommend", $$v)
      },
      expression: "playerForm.recommend"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "20px",
      "padding-top": "40px"
    }
  }, [_c('span', [_vm._v("優先表示動画（おすすめ動画）")])]), _vm._v(" "), _vm._l((_vm.count), function(index) {
    return _c('div', {
      key: index
    }, [_c('el-form-item', {
      attrs: {
        "label": "コンテンツ名",
        "prop": "contents"
      }
    }, [_c('el-select', {
      attrs: {
        "filterable": "",
        "clearable": "",
        "placeholder": "コンテンツ名"
      },
      on: {
        "change": function($event) {
          return _vm.setContents()
        }
      },
      model: {
        value: (_vm.playerForm.contents[index - 1]),
        callback: function($$v) {
          _vm.$set(_vm.playerForm.contents, index - 1, $$v)
        },
        expression: "playerForm.contents[index-1]"
      }
    }, [_c('el-option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.allContents), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "value": item.id,
          "label": item.name
        }
      })
    })], 2)], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-left": "300px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("登録")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fa88057"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contents/Player.vue
// module id = 1134
// module chunks = 1